import { ICompany, TMapItem } from "./types";

const companies: {[k: string]: ICompany} = window._dataCompanies ? JSON.parse(window._dataCompanies) : {}
const mapData = new Map<string, TMapItem>()
let mapinstance:any;

Object.values(companies).forEach(i=>mapData.set(i.code, {
  ...i,
  center: i.coords.split(":"),
  content: {
    // iconContent: e.name,
    balloonContentHeader: "Боксметр " + i.name,
    balloonContentBody: `<div style="width: 260px"><div>${i.address}</div><div>${i.metro}</div></div>`
  }
}))

// window.innerWidth > 991

export function initMap() {
  if(window.innerWidth > 320) {
    try {
      window.ymaps.ready((function() {
          mapinstance = new window.ymaps.Map("map",{center: ['55.755864', '37.617698'], zoom: 9},{searchControlProvider: "yandex#search"})
          mapData.forEach((storage, code)=>{
            const mark = new window.ymaps.Placemark(storage.center, storage.content,{preset: "islands#blueCircleDotIconWithCaption"})
            // mark.events.add('click', function (e: any) {
              // e.get('target').options.unset('preset');
              // e.get('target').options.set('preset', 'twirl#greenIcon');
              // console.log('click' + el.name);
            // });
            mapinstance.geoObjects.add(mark);
          })
      }
      ))
    } catch (r) {}
  }
}